import { Table } from 'antd';
import styled from 'styled-components';
import { Type } from '../../../../../api/responses';
import { theme } from '../../../../../global';

export const DesktopTableWrapper = styled.div`
  display: none;

  @media (min-width: 1100px) {
    display: flex;
  }
`;

export const JudgeWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const TextWrapper = styled.span`
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 500;
  display: flex;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  border-left: 1px solid #17171726;
  border-right: 1px solid #17171726;
  padding: 0 ${theme.spacings.s8};
  font-family: 'Montserrat';
  font-size: 12px;
  font-weight: 600;
  color:${theme.colors.secondaryText};
`;

export const JudgeLineWrapper = styled.div`
  display: flex;
  border-left: 1px solid #17171726;
  border-right: 1px solid #17171726;
  padding: 0 ${theme.spacings.s8};
  flex-direction: column;
  width: 100%;
    height: 100%;
`;

export const PlayerRow = styled.div<{ $hasBorder?: boolean }>`
  display: flex;
  align-items: center;
  height: 50%;
  min-height: 40px;
  position: relative;
  gap: ${theme.spacings.s8};
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0%;

  ${(props) =>
    props.$hasBorder &&
    `
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 8px;
      right: 8px;
      height: 0;
      border-bottom: 1px solid #17171726;
    }
  `}
`;

export const StyledTable = styled(Table) <{ $competitionType: Type }>`
  width: 1200px;

  /* Убираем все скругления */
  .ant-table-container,
  .ant-table-container table > thead > tr:first-child > *:first-child,
  .ant-table-container table > thead > tr:first-child > *:last-child,
  .ant-table-container table > tbody > tr:last-child > *:first-child,
  .ant-table-container table > tbody > tr:last-child > *:last-child {
    border-radius: 0 !important;
  }

  .ant-table-thead > tr > th {
    height: auto;
    padding: 0;
    background: ${(props) => {
    switch (props.$competitionType) {
      case 'team':
        return theme.colors.greenHeader;
      case 'quick':
        return theme.colors.orangeHeader;
      case 'classic':
        return theme.colors.purpleHeader;
      default:
        return theme.colors.purpleHeader;
    }
  }} !important;
    font-family: 'Montserrat';
    font-size: 14px;
    font-weight: 600;
    color: ${theme.colors.secondaryText};
    border: none;
    vertical-align: middle;
  }

  .ant-table-tbody > tr > td {
    padding: 0;
    border-bottom: none;
    font-family: 'Montserrat';
    font-size: 14px;
    text-align: center;
    border-right: none;
    border-left: none;
    vertical-align: top;
    height: 80px;
  }

  /* Бордер между первой и второй строкой игрока - только для 4-7 ячейки */
  .ant-table-tbody > tr:not([data-row-key*="reserve"]):nth-child(3n-1) > td:nth-child(n+4):nth-child(-n+7) {
    border-bottom: 1px solid #17171726;
  }

  /* Бордеры между группами (под резервными судьями) */
  .ant-table-tbody > tr[data-row-key*="reserve"] > td {
    border-bottom: 1px solid ${theme.colors.line};
  }

  /* Строка с резервными судьями - высота по контенту */
  .ant-table-tbody > tr[data-row-key*="reserve"] > td {
    height: auto;
    min-height: 40px;
    padding: 8px 4px;
  }

  .ant-table-container {
    border-radius: 0;
    overflow: hidden;
    border: none;
  }

  .ant-table {
    border-spacing: 0;
    border-collapse: collapse;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    border-right: none;
    border-left: none;
  }

  .ant-table-tbody > tr:last-child > td {
    border-bottom: none;
  }

  .ant-table-tbody > tr > td {
    display: table-cell;
    vertical-align: middle;
  }

  /* Стили для четных групп (каждая группа = 3 строки: игрок1, игрок2, резервные судьи) */
  .ant-table-tbody > tr.even-game-group > td {
    background: ${(props) => {
    switch (props.$competitionType) {
      case 'team':
        return '#F8FCF8';
      case 'quick':
        return '#FEFBF4';
      case 'classic':
        return '#F8F9FB';
      default:
        return '#F8F9FB';
    }
  }};
  }

  /* Дополнительные классы для специфичных стилей если нужно */
  .ant-table-tbody > tr.team-even-group > td {
    background: #f8fcf8;
  }

  .ant-table-tbody > tr.quick-even-group > td {
    background: #fefbf4;
  }

  .ant-table-tbody > tr.classic-even-group > td {
    background: #f8f9fb;
  }
`;


